import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function Reviews() {
  const { t } = useI18n();
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data || []));
  }, []);

  return (
    <div className="pt-32 pb-24 px-6 md:px-12" data-testid="reviews-page">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <div className="label-luxury mb-4">{t("whispered")}</div>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light tracking-tight">
            {t("from_clients_1")} <span className="italic gold-text">{t("from_clients_2")}</span>
          </h1>
          <p className="text-white/55 mt-6 max-w-xl mx-auto">
            {t("reviews_intro")}
          </p>
        </div>

        <div className="space-y-px bg-white/5 border border-white/5">
          {reviews.map((r) => (
            <article
              key={r.id}
              data-testid={`review-item-${r.id}`}
              className="bg-[#0a0a0a] p-10 md:p-14"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="text-[var(--gold)] tracking-[0.3em]">★ ★ ★ ★ ★</div>
                <div className="label-luxury text-[0.6rem]">{r.source}</div>
              </div>
              <p className="font-serif-display text-2xl md:text-3xl font-light italic leading-snug text-white/85">
                "{r.text}"
              </p>
              <div className="mt-8 text-white/60 tracking-wider text-sm uppercase">
                — {r.author}
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
